import angular from 'angular';

const docEl = document.documentElement;
let matchingFunction;

if (docEl.matches) {
  matchingFunction = 'matches';
} else if (docEl.matchesSelector) {
  matchingFunction = 'matchesSelector';
} else if (docEl.webkitMatches) {
  matchingFunction = 'webkitMatches';
} else if (docEl.webkitMatchesSelector) {
  matchingFunction = 'webkitMatchesSelector';
} else if (docEl.msMatches) {
  matchingFunction = 'msMatches';
} else if (docEl.msMatchesSelector) {
  matchingFunction = 'msMatchesSelector';
} else if (docEl.mozMatches) {
  matchingFunction = 'mozMatches';
} else if (docEl.mozMatchesSelector) {
  matchingFunction = 'mozMatchesSelector';
}

function getIsMatchFn(arg) {
  if (angular.isString(arg)) {
    return (element) => element[matchingFunction](arg);
  } else if (arg instanceof angular.element) {
    return (element) => Array.prototype.slice.call(arg).some((item) => item === element);
  } else if (arg instanceof HTMLElement) {
    return (element) => arg === element;
  }

  throw new Error('unexpected argument to angular.prototype.closest');
}

angular.element.prototype.closest = function closest(arg) {
  let el = this[0];
  const isMatch = getIsMatchFn(arg);

  while (
    el !== document.documentElement &&
    el !== null &&
    el.nodeType !== Node.DOCUMENT_FRAGMENT_NODE &&
    !isMatch(el)
  ) {
    el = el.parentNode;
  }

  if (el && el !== null && el.nodeType !== Node.DOCUMENT_FRAGMENT_NODE && isMatch(el)) {
    return angular.element(el);
  }
  return angular.element();
};
